import { E_ColoriMetallo, E_GenereOmbrellone, E_MainLato, E_MisureOmbrelloni, E_PedanaRivestimento, E_PedanaStepAltezza, E_TipoOmbrellone, E_TipoParavento, E_ColoriTessuto, E_KitLedOmbrelloni } from "../Utils/enumerations"

const handleIngresso = (ingresso) => {
    if (ingresso.toString() === E_MainLato.Scegli.toString()) return "Nessuno";
    if (ingresso.toString() === E_MainLato.Lato1.toString()) return "Lato 1";
    if (ingresso.toString() === E_MainLato.Lato2.toString()) return "Lato 2";
    if (ingresso.toString() === E_MainLato.Lato3.toString()) return "Lato 3";
    if (ingresso.toString() === E_MainLato.Lato4.toString()) return "Lato 4";
}
const handleStepAltezza = (altezzaPedana) => {
    if (altezzaPedana.toString() === E_PedanaStepAltezza.Da0a50.toString()) return "Da 0 a 50mm"
    if (altezzaPedana.toString() === E_PedanaStepAltezza.Da50a95.toString()) return "Da 50 a 95mm"
    if (altezzaPedana.toString() === E_PedanaStepAltezza.Da95a125.toString()) return "Da 95 a 125mm"
    if (altezzaPedana.toString() === E_PedanaStepAltezza.Da125a250.toString()) return "Da 125 a 250mm"
}
const handleRivestimento = (rivestimento) => {
    if (rivestimento.toString() === E_PedanaRivestimento.WPC.toString()) return "WPC"
    if (rivestimento.toString() === E_PedanaRivestimento.ANGELIM.toString()) return "ANGELIM"
}
const handleParaventi = (tipo) => {
    if (tipo.toString() === E_TipoParavento.Slim_100.toString()) return "Slim h.100";
    if (tipo.toString() === E_TipoParavento.Unico_100.toString()) return "Unico h.100";
    if (tipo.toString() === E_TipoParavento.Unico_150.toString()) return "Unico h.150";
    if (tipo.toString() === E_TipoParavento.Smeraldo.toString()) return "Smeraldo h.150";
    if (tipo.toString() === E_TipoParavento.Rubino.toString()) return "Rubino h.150+20";
    if (tipo.toString() === E_TipoParavento.Topazio.toString()) return "Topazio h.150";
    if (tipo.toString() === E_TipoParavento.Screen_Up_100.toString()) return "Screen-Up (escluso da preventivo)";
}
const handleLatiParaventi = (latiArray) => {
    let tempArray = [];
    for (let i=0; i<latiArray.length; i++) {        
        let tempValue = latiArray[i].parav === true ? "SI" : "NO";   
        tempArray[i] = tempValue;
    } 
    return tempArray;
}
const handleLatiCristal = (latiArray) => {
    let tempArray = [];
    for (let i=0; i<latiArray.length; i++) {        
        let tempValue = latiArray[i].cristal === true ? "SI" : "NO";   
        tempArray[i] = tempValue;
    } 
    return tempArray;
}
const handlePorta = (kitPorta) => {  
    if (kitPorta === 0) return "NO"
    if (kitPorta === 1) return "1"
    if (kitPorta === 2) return "2"
}
const handleOmbrelloniGenere = (genere) => {
    if (genere.toString() === E_GenereOmbrellone.Braccio.toString()) return "Braccio";   
    if (genere.toString() === E_GenereOmbrellone.Centrale.toString()) return "Centrale";   
    if (genere.toString() === E_GenereOmbrellone.Sbalzo.toString()) return "Sbalzo";   
}
const handleOmbrelloni = (tipo) => {
    if (tipo.toString() === E_TipoOmbrellone.Scegli.toString()) return "Nessuno";   
    if (tipo.toString() === E_TipoOmbrellone.Avantage.toString()) return "Avantage";   
    if (tipo.toString() === E_TipoOmbrellone.DeLuxe.toString()) return "De Luxe";  
    if (tipo.toString() === E_TipoOmbrellone.Diffusion.toString()) return "Diffusion";    
    if (tipo.toString() === E_TipoOmbrellone.Facility.toString()) return "Facility";   
    if (tipo.toString() === E_TipoOmbrellone.Mezzombra.toString()) return "Mezzombra";   
    if (tipo.toString() === E_TipoOmbrellone.PlatinoBasic.toString()) return "Platino Basic";   
    if (tipo.toString() === E_TipoOmbrellone.PlatinoMedium.toString()) return "Platino Medium";   
    if (tipo.toString() === E_TipoOmbrellone.PratiqueClassic.toString()) return "Pratique Classic";  
    if (tipo.toString() === E_TipoOmbrellone.PratiqueContract.toString()) return "Pratique Contract";   
    if (tipo.toString() === E_TipoOmbrellone.Roma.toString()) return "Roma";    
}

// Dati di base da inviare al file PDF
var datiTabella = {
    main: {lunghezza: 0, larghezza: 0, ingresso: E_MainLato.Scegli, coloreStrutture: E_ColoriMetallo.Antracite},
    pedana: {isSelected: false, stepAltezza: E_PedanaStepAltezza.Da0a50, rivestimento: E_PedanaRivestimento.WPC, minigonna: "NO", pedanaHasRampaDisabili: "NO", predParaventi: "NO", pedanaNumBotole: 0},
    paraventi: {isSelected: false, tipo: E_TipoParavento.Slim_100, lati: [false, false, false, false], perimetro: 0, porta: "NO"},
    ombrelloni: {isSelected: false, genere: E_GenereOmbrellone.Braccio, tipo: E_TipoOmbrellone.Scegli, misura: E_MisureOmbrelloni.Scegli, suMisura: "NO", lato: E_MainLato.Scegli, tessuto: E_ColoriTessuto.T15, nastratura: "NO", velcro: "NO", attacchiEsterni: "NO", grondaie: "NO", mantovana: "NO", numero: 0, hasLed: "NO", tipoLed: E_KitLedOmbrelloni.kit0_5m, hasDimmerTel: "NO", ombrelloniHasContrapposti: "NO"},
    cristal: {isSelected: false, lati: [false, false, false, false], kitPorta: "NO", lunghezzaTotale: 0, numeroSostegni: 0},
    calcolo: {prezziParziali: {}, totale: 0},
    immagini: {arrayImmagini: [], watermarkImage: {}}
}

// Genera la tabella con i dati da inviare al file PDF al momento del salvataggio
const tableGenerator = ( 
    mainLunghezza,
    mainLarghezza,
    mainLatoIngresso,
    mainColoreStrutture,
    isPedanaSelected,
    isParaventiSelected,
    isOmbrelloniSelected,
    isLateraleCristalSelected,
    pedanaStepAltezza,
    pedanaRivestimento,
    pedanaHasMinigonna,
    pedanaHasRampaDisabili,
    pedanaHasPredParaventi,
    pedanaNumBotole,
    paraventiTipo,
    paraventiLati,
    paraventiLunghezzaPerimetro,
    paraventiPorte,
    ombrelloniGenere,
    ombrelloniTipo,
    ombrelloniHasSelezioneMisurAutomatica,
    ombrelloniMisura,
    ombrelloniMisuraAutomatica,
    ombrelloniHasSuMisura,
    ombrelloniDimensioneSuMisura,
    ombrelloniLato,
    ombrelloniColoreTessuto,
    ombrelloniHasMantovana,
    ombrelloniHasGrondaie,
    ombrelloniHasNastratura,
    ombrelloniHasVelcro,
    ombrelloniAttacchiEsterni,
    ombrelloniNumero,
    cristalLati,
    cristalHasKitPorta,
    cristalLunghezzaTotale,
    cristalNumeroSostegni,
    calcoloParziali,
    calcoloTotale,
    exportedImagesArray,
    watermark,
    ombrelloniHasLed,
    ombrelloniLedKitType,
    ombrelloniHasDimmerTelecomando,
    hasOmbrelloniContrapposti
    ) => { 
    // Calcola main
    datiTabella.main = {lunghezza: mainLunghezza, larghezza: mainLarghezza, ingresso: handleIngresso(mainLatoIngresso), coloreStrutture: mainColoreStrutture};
    // Calcola pedana
    datiTabella.pedana = {isSelected: isPedanaSelected, stepAltezza: handleStepAltezza(pedanaStepAltezza), rivestimento: handleRivestimento(pedanaRivestimento), minigonna: pedanaHasMinigonna ? "SI" : "NO", pedanaHasRampaDisabili: pedanaHasRampaDisabili ? "SI" : "NO", predParaventi: pedanaHasPredParaventi ? "SI" : "NO", pedanaNumBotole: pedanaNumBotole}; 
    // Calcola paravento
    datiTabella.paraventi = {isSelected: isParaventiSelected, tipo: handleParaventi(paraventiTipo), lati: handleLatiParaventi(paraventiLati), perimetro: paraventiLunghezzaPerimetro, porta: handlePorta(paraventiPorte)};
    // Calcola ombrelloni
    datiTabella.ombrelloni = {isSelected: isOmbrelloniSelected, genere: handleOmbrelloniGenere(ombrelloniGenere), tipo: handleOmbrelloni(ombrelloniTipo), misura: !ombrelloniHasSelezioneMisurAutomatica ? ombrelloniMisura.toString() : ombrelloniMisuraAutomatica.toString(), suMisura: ombrelloniHasSuMisura ? ombrelloniDimensioneSuMisura : 0, lato: handleIngresso(ombrelloniLato), tessuto: ombrelloniColoreTessuto, nastratura: ombrelloniHasNastratura ? "SI" : "NO", velcro: ombrelloniHasVelcro ? "SI" : "NO", attacchiEsterni: ombrelloniAttacchiEsterni ? "SI" : "NO", grondaie: ombrelloniHasGrondaie ? "SI" : "NO", mantovana: ombrelloniHasMantovana ? "SI" : "NO", numero: ombrelloniNumero, hasLed: ombrelloniHasLed ? "SI" : "NO", tipoLed: ombrelloniLedKitType, hasDimmerTel: ombrelloniHasDimmerTelecomando ? "SI" : "NO", ombrelloniHasContrapposti: hasOmbrelloniContrapposti ? "SI" : "NO"};
    // Calcola laterale cristal
    datiTabella.cristal = {isSelected: isLateraleCristalSelected, lati: handleLatiCristal(cristalLati), kitPorta: cristalHasKitPorta ? "SI" : "NO", lunghezzaTotale: cristalLunghezzaTotale, numeroSostegni: cristalNumeroSostegni};
    // Calcola preventivo
    datiTabella.calcolo = {prezziParziali: calcoloParziali, totale: calcoloTotale};
    // Immagini
    datiTabella.immagini = {arrayImmagini: exportedImagesArray, watermarkImage: watermark};
}

export {datiTabella, tableGenerator}